export const toolQuestions = [
  {
    id: "t1",
    type: "tool",
    text: "Du lernst ein neues Mathe-Thema. Was hilft dir am meisten beim ersten Verständnis?",
    options: [
      {
        text: "Ein Erklärvideo oder eine Animation, die den Zusammenhang bildlich zeigt.",
        trait: "visual_media",
      },
      {
        text: "Ein interaktives Tool, mit dem ich Parameter verändern und Effekte direkt sehen kann.",
        trait: "interactive",
      },
      {
        text: "Eine klare Schritt-für-Schritt-Anleitung, die ich systematisch durcharbeite.",
        trait: "systematic",
      },
      {
        text: "Direkt Aufgaben lösen und aus Fehlern lernen – am liebsten mit sofortigem Feedback.",
        trait: "repetitive",
      },
    ],
  },
  {
    id: "t2",
    type: "tool",
    text: "Du steckst bei einer Aufgabe fest. Welches Hilfsmittel greifst du zuerst?",
    options: [
      {
        text: "YouTube – ich suche ein Video, das genau diesen Aufgabentyp erklärt.",
        trait: "visual_media",
      },
      {
        text: "GeoGebra oder ein JS-Rechner – ich visualisiere die Situation interaktiv.",
        trait: "interactive",
      },
      {
        text: "KI-Chat – ich erkläre mein Problem und lasse mir den Denkfehler zeigen.",
        trait: "systematic",
      },
      {
        text: "Ich suche eine ähnliche Aufgabe und übe den Typ so lange, bis er sitzt.",
        trait: "repetitive",
      },
    ],
  },
];